/** Eenmalige activatiemelding op Vandaag (dag 3+, ≥1 voltooide taak). */
import { useCallback, useEffect, useRef, useState } from 'react';
import { ONBOARDING_HINT_ACTIVATION_NOTICE } from '@/constants/onboardingHints';
import {
  countCompletedTasks,
  getActivationNoticeEligibility,
} from '@/features/onboarding/utils/activationNoticeUtils';
import { useTier } from '@/features/tier/useTier';
import { markHintSeen } from '@/services/userService';

/**
 * @param {Object} params
 * @param {string | undefined} params.userId
 * @param {import('@/types').Task[]} params.allTasks
 */
export function useActivationNotice({ userId, allTasks }) {
  const { seenHints, profileLoaded, createdAt } = useTier();
  const triggeredRef = useRef(false);
  const [dismissed, setDismissed] = useState(false);
  const [visible, setVisible] = useState(false);
  const [completedCount, setCompletedCount] = useState(0);

  useEffect(() => {
    if (triggeredRef.current || dismissed || !userId || !profileLoaded) {
      return;
    }

    const count = countCompletedTasks(allTasks);
    const { eligible, completedCount: eligibleCount } =
      getActivationNoticeEligibility({
        createdAt,
        now: new Date(),
        completedCount: count,
        seenHints,
      });

    if (!eligible) {
      return;
    }

    triggeredRef.current = true;
    setCompletedCount(eligibleCount);
    setVisible(true);
    void markHintSeen(userId, ONBOARDING_HINT_ACTIVATION_NOTICE);
  }, [
    allTasks,
    createdAt,
    dismissed,
    profileLoaded,
    seenHints,
    userId,
  ]);

  const dismissNotice = useCallback(() => {
    setDismissed(true);
    setVisible(false);
  }, []);

  return {
    showNotice: visible && !dismissed,
    completedCount,
    dismissNotice,
  };
}
